import SectionHeader from './SectionHeader';

export default function ProjectsSection({ data, template, accent }) {
  if (!data.projects || data.projects.length === 0) return null;

  return (
    <div className="resume-section">
      <SectionHeader template={template} accent={accent}>Projects</SectionHeader>
      <div style={{ fontFamily: template.bodyFont, fontSize: '10.5pt', color: '#1c1c1c', lineHeight: 1.5 }}>
        {data.projects.map((p, i) => (
          <div key={i} style={{ marginBottom: i === data.projects.length - 1 ? 0 : '0.1in' }}>
            <div style={{ fontWeight: 600 }}>{p.name}</div>
            {p.description && <div style={{ color: '#2b2b2b', margin: '0.02in 0' }}>{p.description}</div>}
            {p.bullets && p.bullets.length > 0 && (
              <ul style={{ margin: '0.02in 0 0 0', paddingLeft: '0.22in' }}>
                {p.bullets.map((b, j) => (<li key={j}>{b}</li>))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
